module.exports = __webpack_public_path__ + "static/businessman14-14-b10bbd3ad604d877ffe9de1fc95d5040.jpg";